import { LoadingStatus, QrRegisteredType } from '@typings/common';

export interface QrCodeState {
    qrRegistered?: QrRegisteredType;
    status: LoadingStatus;
    error: Nullable<unknown>;
}

export enum EQrCodesType {
    QRSTATIC = 'QRStatic',
    QRDYNAMIC = 'QRDynamic',
    QRVARIABLE = 'QRVariable',
}

export enum CallbackOperations {
    REFUND = 'REFUND',
    SUBSCRIPTION = 'SUBSCRIPTION',
    PAYMENT = 'PAYMENT',
    PAYOUT = 'PAYOUT',
    B2B_INCOMING = 'B2B_INCOMING',
}

export enum ChargeFrequency {
    MONTHLY = 'MONTHLY',
}
